'use strict';

module.exports = function ($uibModal, $state, webhooks) {
    var _this = this;

    this.webhooks = webhooks;

    this.newWebhook = function () {
        if (_this.webhooks.length) {
            return;
        }
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', 'Member', '$http', 'Webhook', function ($uibModalInstance, Member, $http, Webhook) {
                var _this = this;
                this.webhook = {
                    type: 'forms'
                };


                this.saveWebhook = function () {
                    _this.error = '';
                    _this.loading = true;
                    return Webhook.upsert(_this.webhook)
                        .$promise.then(function (webhook) {
                            $uibModalInstance.close(webhook);
                        })
                        .catch(function (error) {
                            console.log(error);
                            _this.error = error.data.error.message;
                            _this.loading = false;
                        });

                };

            }],
            templateUrl: 'dashboard-webhooks/dashboardNewWebhookModal.html',
            controllerAs: 'modal',
            size: 'md',
            windowClass: 'dialog',
            bindToController: true
        }).result.then(function (webhook) {
            _this.webhooks.push(webhook);
        });
    };
};